import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { colorSets } from '@swimlane/ngx-charts/release/utils';
import { PieOptions } from '../../../utils/models/pie-options';
import { customColorSets } from '../../../utils/custom-color-sets';

/**
 * Pie chart component
 * @author Prasanth Venkatesan
 */
@Component({
    selector: 'neu-charts-pie',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-pie-chart 
        [scheme]="colorScheme"
        [results]="data"
        [legend]="options.showLegend"
        [explodeSlices]="options.explodeSlices"
        [labels]="options.showLabels"
        [doughnut]="options.doughnut"
        [gradient]="gradient"
        (select)="mSelectedEvent($event)">
        </ngx-charts-pie-chart>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [`.chart-container{width:100%;height:100%}`]
})
export class PieChartComponent implements OnInit {

    @Input('data') data: any[] = [];
    @Input('options') customOptions: PieOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: PieOptions = new PieOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        Object.assign(this.options, this.customOptions);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
